import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getExpensesApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getExpensesList = createAsyncThunk('getExpensesList', async (payload) => {
  return await getExpensesApi(payload);
});

const getExpensesListSlice = createSlice({
  name: 'getExpensesList', // Unique Name
  initialState,
  reducers: {
    getExpensesListReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getExpensesList.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getExpensesList.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(getExpensesList.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getExpensesListReset } = getExpensesListSlice.actions;

export default getExpensesListSlice.reducer;
